import { cn } from "@/lib/utils";
import { brl, brlCents } from "@/lib/format";
import { useCouple } from "@/hooks/useCouple";

export const Money = ({ value, cents = false, className, testId, sign }) => {
  const { discreet } = useCouple();
  const text = cents ? brlCents(value) : brl(value);
  return (
    <span data-testid={testId} className={cn("num", discreet && "masked", className)} aria-label={discreet ? "valor oculto" : text}>
      {discreet ? "R$ ••••" : `${sign || ""}${text}`}
    </span>
  );
};
